import { connect } from 'react-redux';
import { State } from 'store/state';
import { setHostedFieldsModalAction, submittedPaymentViaHostedFieldsAction } from 'store/state/app/actions';
import { hostedFieldsModalErrorStateSelector, hostedFieldsModalStateSelector, isHostedFieldsGoogleEnableSelector, privateUserMonetizationEventsSourceSelector } from 'store/state/app/selectors';
import { HostedFieldsModal } from './TranzilaPopup';
import { initHostedFieldsPaymentResponseSelector } from 'store/state/mutationsResponse/selectors';
import { isUserPaymentTransactionLoadingSelector, userPaymentTransactionDataSelector } from 'store/state/domainData/selectors/userPaymentTransaction';
import withEvents from 'analytics/withEvents';
import { HostedFieldsProps } from './types';
import { makeVariantToEventsString } from 'store/sagas/analytics/utils';

const mapStateToProps = (state: State) => ({
  modalState: hostedFieldsModalStateSelector(state),
  source: privateUserMonetizationEventsSourceSelector(state),
  handshakeState: initHostedFieldsPaymentResponseSelector(state),
  paymentResult: userPaymentTransactionDataSelector(state),
  isPaymentResultLoading: isUserPaymentTransactionLoadingSelector(state),
  fieldsErrorState: hostedFieldsModalErrorStateSelector(state),
  isGoogleEnable: isHostedFieldsGoogleEnableSelector(state),
});

const mapDispatchToProps = {
  toggleModal: setHostedFieldsModalAction,
  onPaymentSubmit: submittedPaymentViaHostedFieldsAction,
  setModal: setHostedFieldsModalAction,
};

const HostedFieldsModalWithEvents = withEvents<Omit<HostedFieldsProps, 'fieldsErrorState'>>((sendEvent, props) => ({
  onPaymentSubmit: () => {
    sendEvent('user_promotion_plan_submit', 'user', {
      event: {
        promotion_plan: props.modalState && props.modalState.planInfo ? makeVariantToEventsString(props.modalState.planInfo.variant) : undefined,
        source: props.source,
        deal_type: props.modalState ? props.modalState.paymentDealType : undefined,
      },
    });
  },
}))(HostedFieldsModal);

export default connect(mapStateToProps, mapDispatchToProps)(HostedFieldsModalWithEvents);
